import * as React from 'react';
import * as ReqType from '../../../types/ServerRequests';
import { Link } from 'react-router-dom';
import { LoaderButton } from '../../genericComponents/Button/LoaderButton';
import { CoursService } from '../../../services/CoursService';

/**
 * interface Props (le parametre de la classe)
 */
interface Props {
    /**
     * Course: le cours indexé
     */
    course: ReqType.Course;
    /**
     * changer l'état externe du cours indexé
     * @param {Course} course
     * @returns {Promise<void>}
     */
    changeState: (course: ReqType.Course) => Promise<void>;
}

/**
 * interface State (l'état interne de la classe CourseLine)
 */
interface State {
}

/**
 * Ce composant correspond à une ligne de cours d'un tableau de cours.
 * Il prend un cours en paramétre et une méthode qui permet de changer l'état du composant.
 */
export class CourseLine extends React.Component {
    /** le state: l'etat interne */
    state: State;
    /** le props: l'etat externe */
    props: Props;

    /**
     * construit une ligne dans le tableau cours
     * @param {Props} props
     */
    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    /**
     * Fait un get d'un cours depuis le backend
     * duplique la valeur du cours du props
     * @returns {Promise<void>}
     */
    changeCourseServer = () => {
        var newCourse = CoursService.getInstance().duplicateCourse(this.props.course);
        newCourse.status = (this.props.course.status === 0 ? 1 : 0);
        return this.props.changeState(newCourse);
    }

    /**
     * le rendu de la classe CourseLine
     * @returns {JSX.Element}
     */
    render() {
        return (
            <tr key={this.props.course.id}>
                <td>
                    {this.props.course.discipline !== undefined ? this.props.course.discipline.intitule : ''}
                </td>
                <td>
                    {this.props.course.niveau !== undefined ? this.props.course.niveau.intitule : ''}
                </td>
                <td>
                    {this.props.course.details}
                </td>
                <td>
                    {this.props.course.adresse !== undefined ? this.props.course.adresse : ''}
                </td>
                <td>
                    <Link to={'/courses/' + this.props.course.id}>
                        <button className="btn btn-default">
                            <i className="fas fa-plus" />
                        </button>
                    </Link>
                </td>
                {this.props.course.status === 1 ?
                    (
                        <td>
                            <LoaderButton
                                className="btn btn-danger"
                                onClick={this.changeCourseServer}
                                confirmation={true}
                                modalTitle="Désactivation"
                                modalBody={
                                    'Voulez-vous vraiment desactiver le cours : ' + this.props.course.details
                                }
                            >
                                Desactiver
                            </LoaderButton>
                        </td>
                    ) :
                    (
                        <td>
                            <LoaderButton
                                className="btn btn-success"
                                onClick={this.changeCourseServer}
                                confirmation={true}
                                modalTitle="Activation"
                                modalBody={
                                    'Voulez-vous vraiment réactiver le cours : ' + this.props.course.details
                                }
                            >
                                Activer
                            </LoaderButton>
                        </td>
                    )
                }
            </tr>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/CoursesPage/internalComponents/CourseLine.tsx